'use client';

import { useAuthStore } from '@/context/global/stores/authStore';
import { useEffect } from 'react';

type ClientInitializerProps = {
  clientType: string;
};
export const ClientInitializer = ({ clientType }: ClientInitializerProps) => {
  const setClientType = useAuthStore((state) => state.setClientType);
  const initializeUser = useAuthStore((state) => state.initializeUser);

  useEffect(() => {
    if (clientType) {
      setClientType(clientType);
    }
  }, [clientType, setClientType]);

  // Fetch user profile on app load (token persisted in cookie, user is not)
  useEffect(() => {
    initializeUser();
  }, [initializeUser]);

  return null;
};
